import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from 'firebase/fbConfig.js';

import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import Slide from '@material-ui/core/Slide';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';

import styles from 'assets/jss/material-dashboard-pro-react/components/CreateCaseFormStyle.jsx';

import { startCreateThread } from 'store/actions/threadsActions';

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

class Form extends React.Component {
  state = {
    comment: '',
    messageSent: false,
    messageError: false,
  };
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { cid, owner, parties } = this.props.case;
    const { uid, user, users } = this.props;
    let caseNameChat = this.props.case.name;
    // const parties = [ uid ];



    //  THIS MAY BE SLOWING DOWN APPLICATION, PERFORMING THIS SO THAT NOTIFICATIONS CAN SHOW FIRST, LAST AND EMAIL
    var nameInfo = { email: user.email }
    for (var x = 0; x < users.length; x++) {
      if (users[x].uid === uid) {
        nameInfo.firstName = users[x].firstName
        nameInfo.lastName = users[x].lastName
      }
    }

    console.log('nameinfofromcreatethreadform', nameInfo)

    if (owner !== uid) parties.push(owner);
    console.log(parties);
    parties.map((partyID) => {
      console.log(partyID);
      db.collection('users').doc(partyID).collection('notifications').add({
        createdAt: new Date(),
        description: 'New thread',
        name: this.state.threadName,
        cid: cid,
        status: 'new',
        from: nameInfo,
        type: 'newThread',
      });
    });

    this.props.close();
    this.props
      .createNewThread(
        cid,
        parties,
        this.state.threadName,
        this.state.explanation,
        uid,
        caseNameChat
      )
      .then(this.props.onClose, (messageError) => {
        console.error(messageError);
        this.setState({ ...this.state, messageError });
      });
  };

  render() {
    const { classes } = this.props;
    console.log(this.state);

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Thread Submitted!</h4>
            </GridItem>
          </GridContainer>
        ) : (
            <div className={classes.formContainer}>
              <form onSubmit={this.handleSubmit}>
                <GridContainer justify="center">
                  <GridItem xs={11}>
                    <h5 className={classes.bodyText}>
                      <center>
                        <b>New Thread</b>
                      </center>
                    </h5>
                    {this.state.messageError ? (
                      <h5 className={classes.bodyText}>There Has Been An Error</h5>
                    ) : null}

                    <Card style={{ padding: '5px 10px 0px 10px' }}>
                      <b>
                        <CustomInput
                          labelText="Title"
                          id="threadName"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            required: true,
                            type: 'text',
                            disableUnderline: true,
                            multiline: false,
                            rows: 1,
                            onChange: (event) => this.handleChange(event),
                          }}
                        />
                      </b>
                    </Card>
                    <Card style={{ padding: '5px 10px 0px 10px' }}>
                      <CustomInput
                        labelText="Explanation (optional)"
                        id="explanation"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          required: false,
                          type: 'text',
                          disableUnderline: true,
                          multiline: false,
                          rows: 1,
                          onChange: (event) => this.handleChange(event),
                        }}
                      />
                    </Card>
                  </GridItem>
                </GridContainer>
                <Button
                  type="submit"
                  color="primary"
                  style={{
                    width: '91%',
                    marginLeft: '10px',
                    marginBottom: '10px',
                  }}
                >
                  <b>SUBMIT</b>
                </Button>
              </form>
            </div>
          )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  //console.log(state)
  return {
    uid: state.auth.user.uid,
    user: state.auth.user,
    case: state.cases.currentCase,
    users: state.user.users.dataRows
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createNewThread: (cid, parties, name, explanation, uid, caseName) =>
      dispatch(
        startCreateThread({ cid, parties, name, caseName }, explanation, uid)
      ),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(Form);
